import { useEffect } from "react";

// assets
import { SvgRightArrow } from "assets/icons/js/SvgRightArrow";
import { SvgShare } from "assets/icons/js/SvgShare";

// styles
import "./style.scss";
import Modal from "components/LoginAndRegister/Modal";

interface PageProps {
	close360ViewPage: () => void;
	openSharePopup: () => void;
	video360?: string;
}

export default function Lisitng360View({
	close360ViewPage,
	openSharePopup,
	video360,
}: PageProps) {
	useEffect(() => {
		document.body.style.overflowY = "hidden";
		return () => {
			document.body.style.overflowY = "auto";
		};
	}, []);

	return (
		<div className="listing_360-view_page__container-content">
			{video360 && video360.length > 0 ? (
				<iframe
					key="360_video_iframe"
					title="saffronstays-360-video"
					className="listing_360-view_page__iframe"
					allowFullScreen={true}
					allow="accelerometer; magnetometer; gyroscope"
					src={video360}
				></iframe>
			) : (
				<div style={{ width: "100%" }}>
					<p style={{ textAlign: "center" }}>No 360 video available</p>
				</div>
			)}
		</div>
	);
}
